import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
const className = "DrawLinesCmd";
export class DrawLinesCmd {
    constructor() {
        this.lineWidth = 0;
    }
    static create(x, y, points, lineColor, lineWidth) {
        var cmd = Pool.getItemByClass(className, DrawLinesCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.points = points;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        return cmd;
    }
    recover() {
        this.points = null;
        this.lineColor = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        let offset = (this.lineWidth < 1 || this.lineWidth % 2 === 0) ? 0 : 0.5;
        this.points && runner._drawLines(this.x + offset + gx, this.y + offset + gy, this.points, this.lineColor, this.lineWidth, 0);
    }
    getBounds(assembler) {
        assembler.points.push(...this.points);
        assembler.flushPoints(this.x, this.y);
    }
    get cmdID() {
        return DrawLinesCmd.ID;
    }
}
DrawLinesCmd.ID = className;
ClassUtils.regClass(className, DrawLinesCmd);
